import React from 'react';
import { Container } from './styled';
import MenuCalendar from '../../components/MenuCalendar/MenuCalendar';
import QuaterCollapse from '../QuaterCollapse/QuaterCollapse';

const CalendarYearView = (props) => {
  const { setFromDate, setToDate, date, setStartDate, isMonthlyView, setIsMonthlyView, category, setCategory, permissions, startDate } = props;

  const decreaseYear = () => {
    const newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() - 1);
    setStartDate((prev) => ({ ...prev, value: newDate, scrollToCurrentDate: false, scrollAfterLoadData: false }));
  };
  const increaseYear = () => {
    const newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() + 1);
    setStartDate((prev) => ({ ...prev, value: newDate, scrollToCurrentDate: false, scrollAfterLoadData: false }));
  };
  return (
    <Container>
      <div className="menu-calendar">
        <MenuCalendar
          setFromDate={setFromDate}
          setToDate={setToDate}
          decrease={decreaseYear}
          increase={increaseYear}
          date={date}
          setStartDate={setStartDate}
          isMonthlyView={isMonthlyView}
          setIsMonthlyView={setIsMonthlyView}
          category={category}
          setCategory={setCategory}
          permissions={permissions}
          startDate={startDate}
        />
      </div>

      <QuaterCollapse date={date} {...props} />
    </Container>
  );
};

export default CalendarYearView;
